import React from 'react';
import classNames from 'classnames';

import './Progress.scss';

const steps = [
  'Select room and item',
  'What type of issue are you experiencing?',
  'Diagnose'
]

const Progress = ({ currentStep, totalSteps }) => (
  <ul className="progress">
    {steps.map((step, x) => (
      <li
      key={x}
        className={
          classNames(
            'progress__step',
            {
              'progress__step--active': currentStep === x,
              'progress__step--complete': currentStep > x,
            }
          )
        }
      >
        <div className="progress__label">
          {step}
        </div>
      </li>
    ))}
  </ul>
);

export default Progress;
